import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

import { DoubleBevelCut } from '@paragon/contract-library';
import { AngleField } from '@paragon/material';

interface Props {
  bevelCut: DoubleBevelCut;
  disabled: boolean;
  onEditBevelCut: (newBevelCut: DoubleBevelCut) => void;
}

export const DoubleBevelCutProperties: FunctionComponent<Props> = (props: Props) => {
  const { bevelCut, disabled, onEditBevelCut } = props;

  return (
    <Box>
      <AngleField
        label="Front Angle"
        value={bevelCut.frontAngle}
        min={1}
        max={89}
        onSubmit={(frontAngle) => onEditBevelCut({ ...bevelCut, frontAngle })}
        disabled={disabled}
      />

      <AngleField
        label="Back Angle"
        value={bevelCut.backAngle}
        min={1}
        max={89}
        onSubmit={(backAngle) => onEditBevelCut({ ...bevelCut, backAngle })}
        disabled={disabled}
      />
    </Box>
  );
};
